import useDecodedToken from "../utils/useDecodedToken";

// Guards a whole route: useDecodedToken() kicks off the BattleNet login
// redirect when there's no token. Returning null (instead of rendering
// children) here matters — it stops the private page, its sidebar, and its
// nav from ever mounting, so nothing flashes on screen while the browser
// navigates away.
const PrivateRoute = ({ children }) => {
  const { decodedJwt } = useDecodedToken();

  if (!decodedJwt) {
    return null;
  }

  return children;
};

export default PrivateRoute;
